import { PostCrecaAccountsApi } from "@/features/accounts/creca/services/post-accounts-api";
import { PostCrecaAccountsRequestModel } from "@/features/accounts/creca/services/post-accounts-model";

/// クレカ登録処理
export class PostCrecaAccountsService {
  private postCrecaAccountsApi = new PostCrecaAccountsApi();

  /**
   * クレカ登録API実行
   */
  public async postCrecaAccounts(param: PostCrecaAccountsRequestModel) {
    return await this.postCrecaAccountsApi.postCrecaAccounts(param);
  }
}
